import ParamTable from "./ParamTable";
import React from "react";

const columns = [
  { key: "name", title: "name", required: true },
  { key: "url", title: "url", required: true },
  { key: "project", title: "project", required: true },
  { key: "project_uri", title: "project_uri", required: true },
];

export default function ParamRepositories() {
  return <ParamTable table="repositories" title="Dépôts" columns={columns} />;
}
